<div class="historical-curve-points-wrapper">
  <h1 class="page-title">Historical Data Points</h1>
  <p class="sample-label">{{ sampleLabel }}</p>
  <div class="curve-cards">
    @for (card of cards; track card) {
      <section class="curve-card" [ngClass]="{ 'average-card': card.average }">
        <h2 class="curve-card-title">{{ card.title }}</h2>
        <table>
          <thead>
            <tr>
              <th>Moisture (%)</th>
              <th>{{ trHeader }}</th>
            </tr>
          </thead>
          <tbody>
            @for (point of card.points; track point) {
              <tr>
                <td>{{ point.moistureContent }}</td>
                <td>{{ point.tr }}</td>
              </tr>
            }
          </tbody>
        </table>
      </section>
    }
  </div>
  @if (!hasHistoricalCurves) {
    <p class="empty-state">No historical data points for this sample.</p>
  }
</div>
